import * as React from 'react';
import * as SwitchPrimitives from '@radix-ui/react-switch';

import { cn } from '@seller-hermes/utils/cn';

const Switch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitives.Root>,
  React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root>
>(({ className, ...props }, ref) => (
  <SwitchPrimitives.Root
    data-slot="switch"
    className={cn(
      'inline-flex h-6 w-10 shrink-0 cursor-pointer items-center rounded-full outline-none transition-all',
      'data-[state=checked]:bg-primary data-[state=unchecked]:bg-input',
      'group/switch border-2 border-transparent',
      'disabled:cursor-not-allowed disabled:opacity-50',
      'focus-visible:ring-ring focus-visible:ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2',
      className,
    )}
    {...props}
    ref={ref}
  >
    <SwitchPrimitives.Thumb
      data-slot="switch-thumb"
      className={cn(
        'bg-background h-4.5 w-4.5 pointer-events-none block rounded-full shadow-lg ring-0 transition-transform',
        'dark:data-[state=unchecked]:bg-foreground dark:data-[state=checked]:bg-primary-foreground data-[state=checked]:translate-x-[calc(100%-1px)] data-[state=unchecked]:translate-x-0',
      )}
    />
  </SwitchPrimitives.Root>
));
Switch.displayName = SwitchPrimitives.Root.displayName;

export default Switch;
